export type NumberStyleType = 'decimal' | 'currency' | 'percent';

export interface CurrencyWithSuffix {
  amount: number;
  suffix: string;
}

export function formatCurrencyWithSuffix(amount: number): CurrencyWithSuffix {
  if (amount < 1000000) {
    // this is just for safety, the current data set doesn't have any values below 1 million
    return { amount: roundDown(amount), suffix: '' };
  } else if (amount < 1000000000) {
    return { amount: roundDown(amount / 1000000), suffix: 'million' };
  } else {
    return { amount: roundDown(amount / 1000000000), suffix: 'billion' };
  }
}

export function formatNumber(
  amount: number,
  style: NumberStyleType = 'decimal'
): string {
  // Rounding down is the safest thing to do.
  // Particularly if we're closing in on a target and there needs to be a PR announcement moment of reaching a milestone.
  // Don't round down when the value < 1 as it will show as 0

  if (roundDown(amount) > 0) {
    amount = roundDown(amount);
  }

  const fractionDigits = {
    decimal: amount < 1 ? 2 : 0,
    currency: amount < 1 ? 2 : 0,
    percent: amount * 100 < 10 ? 1 : 0
  };

  let options: Intl.NumberFormatOptions = {
    style,
    useGrouping: true,
    maximumFractionDigits: fractionDigits[style],
    minimumFractionDigits: fractionDigits[style]
  };

  if (style === 'currency') {
    options = {
      ...options,
      currency: 'AUD'
    };
  }

  const formatter = new Intl.NumberFormat('en-AU', options);
  return formatter.format(amount);
}

export function roundDown(value: number) {
  return Math.floor(value);
}
